

































































import store from "../../store";
import VipText from "../../components/vipText.vue";
import { isWeixin } from "@ivy/fts/utils";
import * as weixin from "@ivy/fts/weixin";
import showBindPhone from "@ivy/fts/showBindPhone";
import * as qs from "qs";
import { Component, Vue, Prop } from "vue-property-decorator";
import Modal from "./modal.vue";
@Component({
  components: { VipText, Modal },
})
export default class VipPage extends Vue {
  user: any = {};
  isWeixin: boolean = isWeixin();
  showOpenVip: boolean = false;
  showUser: boolean = false;
  goods: any = [];
  showPop = false;
  popData: any = {};
  choosetid;
  async mounted() {
    await this.$store.login();
    let { result, action, tid } = this.$route.query;
    const message = {
      "chooseWXPay:ok": "会员开通成功",
      "chooseWXPay:fail": "支付失败",
      "chooseWXPay:cancel": "支付取消",
    };
    if (message[`${result}`]) {
      this.$Toast(message[`${result}`]);
    } else if (action === "pay") {
      this.$Toast("会员开通成功");
    }
    this.choosetid = tid;
    await this.getVipGoods();
    this.showOpenVip = !result && action === "callPay";
    this.user = this.isWeixin
      ? store.logined
      : store.logined.user
      ? Object.assign(store.logined.user, {
          token: store.logined.token,
          vip: store.logined.vip,
        })
      : {};
    this.showUser = true;
    this.showPopup();
  }
  async showPopup() {
    if (!this.choosetid) return;
    let { data } = await this.$axios.get(
      `/api/goods/order/common/qrCode/qRCodeByGoods`,
      {
        params: {
          tid: this.choosetid,
        },
      }
    );
    if (data) {
      this.popData = data;
      this.showPop = true;
    }
  }
  async weChatPay(id) {
    if (!store.logined.token) {
      this.showOpenVip = false;
      return this.toRelation();
    }
    this.$Indicator.open({
      text: "加载中",
      spinnerType: "fading-circle",
    });
    let order = {
      type: "vip",
      openid: store.logined.openid,
      id,
    };
    let { data: pay } = await this.$axios.post(
      `/api/goods/order/old/general/createOrderWechat`,
      order
    );
    delete pay.order;
    let baseUrl = window.location.href.split("&tid=")[0].split("tid=")[0];
    let redirect = `${baseUrl}&${qs.stringify({
      tid: pay.tid,
    })}`;
    window.location.href = `${window.location.origin}/pay/?${qs.stringify({
      pay,
      redirect: redirect,
    })}`;
  }
  async getVipGoods() {
    const { data } = await this.$axios.post(
      `/api/goods/shop/search/goods/vipGoods`
    );
    this.goods = data;
  }
  toCash() {
    return !!store.logined.token
      ? this.$router.push("/vip/cash")
      : this.toRelation();
  }
  async toRelation() {
    let res = await showBindPhone(); // 弹出绑定手机号的窗口
    // 绑定成功之后重新登录
    if (res.message === "ok" || res.user) {
      store.logined = res.logined;
      this.$router.go(0);
    }
  }
}
